<div class="dialog-header">
  <h2 mat-dialog-title>Generating PDF Report</h2>
  <mat-icon>picture_as_pdf</mat-icon>
</div>

<mat-dialog-content>
  <div *ngIf="(progress$ | async) as progress">
    <!-- <mat-progress-bar mode="determinate" [value]="progressValue.value"></mat-progress-bar> -->
    <div *ngIf="progress.status !== 'error'" class="page-progress__title">
      {{progress.pageTitle ?? ''}}
    </div>

    <div *ngIf="progress.status !== 'error'" class="page-progress__list">
      <div *ngFor="let pageIndex of getPageIndices(progress.totalPages)" class="page-progress-item">
        <mat-progress-bar 
          [mode]="getProgressBarMode(pageIndex, progress.currentPage, progress.status)"
          [value]="getProgressBarValue(pageIndex, progress.currentPage, progress.status)">
        </mat-progress-bar>
      </div>
    </div>
  
    <div *ngIf="progress.status === 'error'">
      <strong>PDF generation errors:</strong><br />
      <div [innerHTML]="getSanitizedErrorMessage(progress)"></div>
    </div>
  </div>
</mat-dialog-content>